'use client';
import { motion } from 'framer-motion';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { PricingTables } from '@/components/PricingTables';

export default function PricingPage() {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const staggerChildren = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <div className="min-h-screen flex flex-col font-sans overflow-hidden">
      <Navbar />

      <main className="flex-grow pt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <motion.div className="text-center mb-12" initial="hidden" animate="visible" variants={staggerChildren}>
            <motion.h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl" variants={fadeIn}>
              Choose Your Plan
            </motion.h1>
            <motion.p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto" variants={fadeIn}>
              Presentation-ready charts, without the busywork. Start free and add more AI capacity when you need it.
            </motion.p>
          </motion.div>

          <motion.div initial="hidden" animate="visible" variants={staggerChildren}>
            <PricingTables />
          </motion.div>

          <motion.div className="mt-16 text-center" variants={fadeIn} initial="hidden" animate="visible">
            <h2 className="text-2xl font-semibold mb-4 text-foreground">Questions about your plan?</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto mb-8">
              Existing subscribers keep their current price unless they choose a plan change. Contact us if you need
              help.
            </p>
            <div className="inline-flex items-center space-x-2 p-4 bg-card/50 backdrop-blur-sm rounded-lg shadow-md border border-border">
              <span className="text-muted-foreground">Email us at:</span>
              <a
                href="mailto:support@slashml.com"
                className="text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300 font-medium">
                support@slashml.com
              </a>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
